import moment from 'moment'

import { ProductsNormalized } from '../containers/economicCycles/InvetoriesRealTime'
import { IpvData } from '../interfaces/Interfaces'
import { BusinessInterface } from '../interfaces/ServerInterfaces'
import { translateMeasure } from '../utils/translate'
import Report from './components/Report'
import PdfIcon from './components/report/IconPdf'

/*interface IpvProductExtended extends IpvProduct {
  variations: IpvProduct[];
}*/

interface IpvDataExtended extends IpvData {
  dateFrom?: string
  dateTo?: string
  area: string
}

interface InventoryStatusReportProps {
  reportName: string
  businessData: BusinessInterface
  reportData: {
    products: ProductsNormalized[]
    details: IpvDataExtended
  }
}

const formatNumber = (value: number | undefined | null) => {
  if (!value || value === 0) return '' // si es 0, null o undefined, devolvemos vacío
  return value
}

const InventoryStatusProductsReport = ({
  reportName,
  businessData,
  reportData,
}: InventoryStatusReportProps) => {
  const products: unknown[] = []

  reportData.products?.forEach((item) => {
    products.push([
      item.category?.name + '~subtitle',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
    ])
    if (item.products?.length)
      item.products.forEach((product) => {
        products.push([
          product.productName + '~indexed',
          '',
          translateMeasure(product.productMeasure),
          formatNumber(Number(product.startsWith)),
          formatNumber(Number(product.entryBuy)),
          formatNumber(Number(product.entryFastEntry)),
          `${formatNumber(Number(product.entryTraslate))}\n${formatNumber(Number(product.outTraslate))}`,
          `${formatNumber(Number(product.entryProcessed ?? 0))}\n${formatNumber(Number(product.outProcessed ?? 0))}`,
          `${formatNumber(Number(product.entryDispatch))}\n${formatNumber(Number(product.outDispatch))}`,
          formatNumber(Number(product.outExtraction)),
          `${formatNumber(Number(product.entryTransformation))}\n${formatNumber(Number(product.outTransformation))}`,
          `${formatNumber(Number(product.entryAdjust))}\n${formatNumber(Number(product.outAdjust))}`,
          formatNumber(Number(product.outWaste)),
          formatNumber(Number(product.outSale)),
          formatNumber(Number(product.endsWith)),
          formatNumber(Number(product.reserved)),
        ])
        if (product.variations?.length)
          product.variations.forEach((variation) =>
            products.push([
              '-    ' + variation.variationName + '~indexed',
              '',
              translateMeasure(product.productMeasure),
              formatNumber(Number(variation.startsWith)),
              formatNumber(Number(variation.entryBuy)),
              formatNumber(Number(variation.entryFastEntry)),
              `${formatNumber(Number(variation.entryTraslate))}\n${formatNumber(Number(variation.outTraslate))}`,
              `${formatNumber(Number(variation.entryProcessed ?? 0))}
              \n${formatNumber(Number(variation.outProcessed ?? 0))}`,
              `${formatNumber(Number(variation.entryDispatch))}\n${formatNumber(Number(variation.outDispatch))}`,
              formatNumber(Number(variation.outExtraction)),
              `${formatNumber(Number(variation.entryTransformation))}
              \n${formatNumber(Number(variation.outTransformation))}`,
              `${formatNumber(Number(variation.entryAdjust))}\n${formatNumber(Number(variation.outAdjust))}`,
              formatNumber(Number(variation.outWaste)),
              formatNumber(Number(variation.outSale)),
              formatNumber(Number(variation.endsWith)),
              formatNumber(Number(variation.reserved)),
            ])
          )
      })
  })

  const subsections: Record<string, string> = {}
  if (reportData.details.dateFrom)
    subsections['Fecha de apertura:~subtitle'] = moment(
      reportData.details.dateFrom
    ).format('DD [de] MMMM YYYY')
  subsections['Área:~subtitle'] = reportData.details.area

  const data = [
    `${reportName}~title`,
    'titleSeparator',
    {
      display: 'section',
      widths: [[25, 1]],
      subsections: [subsections],
    },
    'sectionSeparator',
    {
      display: 'table',
      widths: [6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
      headers: [
        '',
        <PdfIcon key="scale" name="scale" size={10} />,
        <PdfIcon key="play" name="play" size={10} />,
        <PdfIcon key="shopping-cart" name="shopping-cart" size={10} />,
        <PdfIcon key="log-in" name="log-in" size={10} />,
        <PdfIcon key="package" name="package" size={10} />,
        <PdfIcon key="activity" name="activity" size={10} />,
        <PdfIcon key="truck" name="truck" size={10} />,
        <PdfIcon key="logOut" name="logOut" size={10} />,
        <PdfIcon key="repeat" name="repeat" size={10} />,
        <PdfIcon key="settings" name="settings" size={10} />,
        <PdfIcon key="trash2" name="trash2" size={10} />,
        <PdfIcon key="dollarSign" name="dollarSign" size={10} />,
        <PdfIcon key="flag" name="flag" size={10} />,
        <PdfIcon key="warehouse" name="warehouse" size={10} />,
      ],
      values: products,
    },
  ]

  return (
    <Report
      headerData={businessData}
      reportData={data}
      reportName={reportName}
      signLineTexts={['Elaborado por', 'Aprobado por']}
    />
  )
}

export default InventoryStatusProductsReport
